import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState("");

  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const email = Cookies.get("email");
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    let validationErrors = {};

    if (!email) {
      setError("Email not found. Please try again.");
      return;
    }

    if (!newPassword) {
      validationErrors.password = "Password is required";
    }

    if (!confirmPassword) {
      validationErrors.confirmPassword = "Confirm Password is required";
    }
    if (Object.keys(validationErrors).length > 0) {
      setError(validationErrors);
      return;
    }



    try {
      const response = await axios.put(
        `${API_BASE_URL}update-password/${email}`,
        {
          password: newPassword,
          confirmPassword: confirmPassword,
        }
      );

      if (response.status === 200) {
        setMessage("Password has been reset successfully!");
        navigate("/");
      } else {
        setError(
          response.data.message ||
          "An error occurred while resetting the password."
        );
      }
    } catch (err) {
      const backendError = err.response?.data;
      if (backendError?.args && backendError.args[0]?._schema) {
        const backendMessage = backendError.args[0]._schema[0];
        if (backendMessage === "Password does not match") {
          setError((prev) => ({ ...prev, confirmPassword: backendMessage }));
        } else {
          setError((prev) => ({ ...prev, confirmPassword: backendMessage }));
        }
      } else {
        setError((prev) => ({ ...prev, confirmPassword: backendError?.message || "An error occurred. Please try again." }));
      }
    }


  };

  return (

    <div className="container">
      <div className="reset-password-page">
        <h3 className="text-center">Choose a new password</h3>

        {message && <p style={{ color: "green" }}>{message}</p>}

        <div className="form rounded-2 white-box-shadow">
          <form className="reset-password-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label>New Password:</label>
              <div className="form-field position-relative">
                <i className="fa-solid fa-lock"></i>
                <input
                  className="form-control"
                  placeholder="New Password"
                  type={showPassword ? "text" : "password"}
                  value={newPassword}
                  onChange={(e) => {
                    setNewPassword(e.target.value);
                    setError((prev) => ({ ...prev, password: "" }));
                  }}

                />
                <span
                  onClick={() => setShowPassword((prev) => !prev)}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "15px",
                    cursor: "pointer",
                    color: "gray",
                  }}
                >
                  {showPassword ? <FaEye size={20} /> : <FaEyeSlash size={20} />}
                </span>
                {error.password && <small className="text-danger">{error.password}</small>}
              </div>
            </div>
            <div className="form-group mt-3">
              <label>Confirm Password:</label>
              <div className="form-field position-relative">
                <i className="fa-solid fa-lock"></i>
                <input
                  className="form-control"
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={(e) => {
                    setConfirmPassword(e.target.value);
                    setError((prev) => ({ ...prev, confirmPassword: "" }));
                  }}

                />
                <span
                  onClick={() => setShowConfirmPassword((prev) => !prev)}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "15px",
                    cursor: "pointer",
                    color: "gray",
                  }}
                >
                  {showConfirmPassword ? <FaEye size={20} /> : <FaEyeSlash size={20} />}
                </span>
                {error.confirmPassword && <small className="text-danger">{error.confirmPassword}</small>}
              </div>
            </div>
            <div className="form-group form-btns mt-3">
              <div className="form-field">
                <button type="submit" className="ls-btn">
                  Reset Password
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
